import React from 'react';
import { PlanIdToNameMap, ChargeBeePlanId } from '@prerender/billing-shared';

import { useSelector } from '../../hooks/usePrerenderUser';
import { HOURS_IN_SECONDS } from './sitemapUtil';

const SORTED_PLANS = [
  ChargeBeePlanId.EnterprisePlus,
  ChargeBeePlanId.Pro,
  ChargeBeePlanId.Growth,
  ChargeBeePlanId.Starter,
];

const INTERVALS = [
  // from EnterprisePlus
  {
    key: (1 * HOURS_IN_SECONDS).toString(),
    value: 1 * HOURS_IN_SECONDS,
    label: '1 hour',
  },
  // from Pro
  {
    key: (8 * HOURS_IN_SECONDS).toString(),
    value: 8 * HOURS_IN_SECONDS,
    label: '8 hours',
  },
  // from Growth
  {
    key: (24 * HOURS_IN_SECONDS).toString(),
    value: 24 * HOURS_IN_SECONDS,
    label: '24 hours',
  },
  // from Starter
  {
    key: (7 * 24 * HOURS_IN_SECONDS).toString(),
    value: 7 * 24 * HOURS_IN_SECONDS,
    label: '7 days',
  },
];

export type RevisitIntervalOption = {
  upsellTooltip?: string;
  upsellPlanId?: ChargeBeePlanId;
  label: string;
  value: number;
  key: string;
};

function useRevisitIntervalOptions() {
  const currentPlanId = useSelector((state) => state.prerenderUser.chargebeePlanId);

  const options: RevisitIntervalOption[] = React.useMemo(
    () =>
      INTERVALS.map((interval, index) => {
        const currentPlanIndex = SORTED_PLANS.findIndex((plan) => plan === currentPlanId);
        const isLocked = currentPlanIndex > -1 && currentPlanIndex > index;
        return {
          ...interval,
          upsellTooltip: isLocked ? `Click to upgrade to ${PlanIdToNameMap[SORTED_PLANS[index]]}` : undefined,
          upsellPlanId: isLocked ? SORTED_PLANS[index] : undefined,
        };
      }),
    [currentPlanId]
  );

  return options;
}

export default useRevisitIntervalOptions;
